import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  orderProductsLarge: {
    flex: 0.8,
    flexDirection: 'column',
    backgroundColor: '#fff',
    marginTop: 'auto',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    shadowOpacity: 0.15,
    shadowOffset: {
      height: 3,
      width: 1,
    },
  },
  orderProductsSmall: {
    flex: 0.75,
    flexDirection: 'column',
    backgroundColor: '#fff',
    marginTop: 'auto',
    alignSelf: 'center',
    width: '100%',
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    shadowOpacity: 0.15,
    shadowOffset: {
      height: 3,
      width: 1,
    },
  },
  modalProductsContainerLarge: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '1%',
    paddingHorizontal: 20,
  },
  modalProductsContainerSmall: {
    flex: 1,
    marginBottom: '5%',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  returnContainer: {
    backgroundColor: '#fff',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  iconLarge: {
    flex: 0.2,
    alignSelf: 'center',
    color: '#0F6657',
  },
  iconSmall: {
    flex: 0.15,
    alignSelf: 'center',
    color: '#0F6657',
  },
  containerIcon: {
    backgroundColor: '#fff',
    borderRadius: 15,
  },
  closeContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 15,
    marginRight: 20,
  },
  goToPaymentText: {
    color: '#0F6657',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25,
    textAlign: 'center',
    alignSelf: 'center',
  },
  productsContainer: {
    flex: 1,
  },
  productContainerScrollContent: {
    justifyContent: 'space-evenly',
    flexDirection: 'column',
  },
  sectionContainerTitleSmall: {
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.1,
    textAlign: 'left',
  },
  sectionContainerTitleLarge: {
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.1,
    textAlign: 'right',
    alignSelf: 'flex-start',
  },
  productsContainerLarge: {
    flex: 1,
    marginTop: '1%',
    paddingVertical: '2%',
    paddingHorizontal: '5%',
    justifyContent: 'flex-start',
  },
  productsContainerSmall: {
    flex: 1,
    justifyContent: 'flex-start',
    marginTop: '2%',
    paddingVertical: '5%',
    paddingHorizontal: '5%',
  },
  itemTextProduct: {
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: 0.25,
    textAlign: 'left',
    alignSelf: 'flex-start',
  },
  rowLarge: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '5%',
    paddingBottom: '3%',
  },
  rowSmall: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: '2%',
    marginTop: '2%',
    paddingBottom: '1%',
    paddingTop: '2%',
  },
  totalAmountContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  totalAmountTextLarge: {
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 24,
    letterSpacing: 0.25,
  },
  totalAmountTextSmall: {
    fontWeight: '700',
    fontSize: 18,
    lineHeight: 24,
    letterSpacing: 0.25,
  },
  paymentButtonDownContainerSmall: {
    flex: 0.2,
    paddingHorizontal: 20,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  paymentButtonDownContainerLarge: {
    alignSelf: 'center',
    flexDirection: 'column',
    width: '80%',
  },
  paymentButtonContainerLarge: {
    width: '50%',
    marginTop: '1%',
    marginBottom: '5%',
    borderRadius: 4,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  paymentButtonContainerSmall: {
    width: '80%',
    borderRadius: 4,
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: '2%',
  },
  paymentButtonTitle: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 16,
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
});
